import { render, staticRenderFns } from "./photo.vue?vue&type=template&id=4f787492&scoped=true&"
import script from "./photo.vue?vue&type=script&lang=ts&"
export * from "./photo.vue?vue&type=script&lang=ts&"
import style0 from "./photo.vue?vue&type=style&index=0&id=4f787492&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f787492",
  null
  
)

export default component.exports